// extracted by mini-css-extract-plugin
export var adjacentSlide = "_oh-9";
export var arrowButtonContainer = "_oh-5";
export var arrowButtonIcon = "_oh-6";
export var carouselArrowButton = "_oh-2";
export var carouselElementContainer = "_oh-1";
export var currentSlide = "_oh-8";
export var left = "_oh-3";
export var otherSlide = "_oh-a";
export var productCarouselContainer = "_oh-0";
export var right = "_oh-4";
export var sliderOverflow = "_oh-7";